import React from 'react';
import TabsContainer from "./TabsContainer";
var TabsContainerForwardingRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TabsContainer, Object.assign({}, props, {
    innerRef: ref
  }));
});
export default TabsContainerForwardingRef;